export default __webpack_public_path__ + "static/media/diversity3.e85f8d9b.webp";